export enum ProcedureStatus {
    aborted = 'aborted',
    active = 'active',
    cancelled = 'cancelled',
    completed = 'completed',
    inProgress = 'in-progress',
    suspended = 'suspended',
}
